module.exports = __webpack_public_path__ + "static/feedback180-868363d9fd6647b81a0d374e61c196b8.png";